import { render, staticRenderFns } from "./AdConsentModal.vue?vue&type=template&id=34b022d6&scoped=true"
import script from "./AdConsentModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdConsentModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AdConsentModal.vue?vue&type=style&index=0&id=34b022d6&prod&scoped=true&lang=css"
import style1 from "./AdConsentModal.vue?vue&type=style&index=1&id=34b022d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b022d6",
  null
  
)

export default component.exports